<template>
	<div class="full-width">
		<h5>Set an appointment</h5>

		<div class="d-flex flex-wrap align-center mt-4">
			<slot name="try-again" />
			<v-spacer />
			<v-btn class="mx-1 my-1" color="q_blue_1" depressed @click="showDialog = true">
				<v-icon left>icon-events</v-icon>
				<v-divider class="mx-1" vertical />
				Set an appointment
			</v-btn>
		</div>

		<v-dialog v-if="showDialog" v-model="showDialog" max-width="540px">
			<v-card>
				<v-card-title>
					<p><strong>QFA</strong>'s Calendar</p>
				</v-card-title>
				<v-card-text>
					<p>Clicking <strong>OK</strong> will assign a QFA to your reset.</p>
					<p>You'll have 15 minutes to choose a different product and SME if needed to accommodate the client.</p>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="py-4 px-6">
					<v-btn color="q_blue_1" outlined @click="showDialog = false">Cancel</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="q_blue_1" depressed @click="setAppointment">Ok</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
    data () {
        return {
			showDialog: false,
			QRSCalendarLink: 'https://qfa.zohobookings.com/#/customer/retirementreview',
        }
    },
	methods: {
        setAppointment () {
            this.$emit('qrs-confirmed')
			window.open(this.QRSCalendarLink, '_blank')
			this.showDialog = false
        },
    },
}
</script>
